window.PlanCancel = (function () {
    let self = {
        elements: {
            planCancelForm: '#plan-cancel',
            button: {
                cancelButton: '#plan-cancel-cancel',
                continueButton: '#plan-cancel-continue'
            },
            messages: {
                error: '#plan-cancel-error'
            },
            radioButton: {
                radioButton1: '#plan-cancel-button-1',
                radioButton2: '#plan-cancel-button-2'
            }
        },
        constants: {
            discussCancellation: 'discusscancellation',
            justCancellation: 'justcancellation'
        },
        css: {
            invalidRadioButtonsClass: 'vds-form__radios--error',
            radioButtonsContainer: '.vds-form__radios'
        },
        urls: {
            managePlanPageUrl: '/my-health-insurance/manage-my-plan',
            discussCancelPageUrl: '/my-health-insurance/manage-my-plan/plan-cancellation/discuss-cancellation',
            justCancelPageUrl: '/my-health-insurance/manage-my-plan/plan-cancellation/just-cancel',
            errorPageUrl: '/error/error-page',
            updateSessionUrl: '/api/sitecore/PolicyCancellation/UpdatePlanCancellationSession'
        },
        statusDescription: {
            accepted: 'accepted'
        },
        func: {
            init: function () {
                self.func.bindings();
                $(self.elements.messages.error).hide();
                $(self.css.radioButtonsContainer).removeClass(self.css.invalidRadioButtonsClass);
            },
            bindings: function () {
                $(self.elements.planCancelForm).on('submit', self.func.handleContinue);
                $("input:radio[name='radios-contained']").on('change', self.func.clearValidation);
            },
            clearValidation: function () {
                $(self.elements.messages.error).hide();
                $(self.css.radioButtonsContainer).removeClass(self.css.invalidRadioButtonsClass);
            },
            handleContinue: function (event) {
                event.preventDefault();
                const radioButton1 = $(self.elements.radioButton.radioButton1).is(':checked');
                const radioButton2 = $(self.elements.radioButton.radioButton2).is(':checked');
                if (!radioButton1 && !radioButton2) {
                    $(self.elements.messages.error).show();
                    $(self.css.radioButtonsContainer).addClass(self.css.invalidRadioButtonsClass);
                }
                let reason = '';
                if (radioButton1) {
                    reason = self.constants.discussCancellation;
                }
                if (radioButton2) {
                    reason = self.constants.justCancellation;
                }
                $.ajax({
                    url: self.urls.updateSessionUrl,
                    type: 'POST',
                    data: { reason: reason }
                })
                    .done(function () {
                        if (radioButton1) {
                            window.location.href = self.urls.discussCancelPageUrl;
                        }
                        if (radioButton2) {
                            window.location.href = self.urls.justCancelPageUrl;
                        }
                    });
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('plan-cancel' === $('#plan-cancel').data('feature')) {
        window.PlanCancel.Init();
    }
});
